// NOTE: hooks
import useNavBar from './useNavBar'
import { Link } from 'react-router-dom'
// NOTE: components
import DeskNav from './DeskNav'
import PhoneNav from './PhoneNav'
import Logo from '../Logo'

const NavBar = () => {
	const {
		navLinks,
		currentPageCTA,
		showNav,
		setShowNav
	} = useNavBar()

	return (
		<header className="sticky top-0 z-40 bg-white/[0.92] backdrop-blur-md">
			<a
				href="#main"
				className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4
					focus:z-50 focus:rounded-lg focus:bg-brand focus:px-4 focus:py-2 focus:text-white"
			>
				Skip to content
			</a>

			<div className="mx-auto flex w-full max-w-7xl items-center justify-between px-5 py-4 sm:px-8">
				<Link to="/" className="text-slate-900">
					<Logo />
				</Link>

				<DeskNav
					navLinks={navLinks}
					currentPageCTA={currentPageCTA}
					className="hidden md:flex"
				/>

				<PhoneNav
					navLinks={navLinks}
					currentPageCTA={currentPageCTA}
					showNav={showNav}
					setShowNav={setShowNav}
					className="md:hidden"
				/>
			</div>
		</header>
	)
}

export default NavBar
